unit ResultType;
{

/* Initial. */

}
interface

uses
  SysUtils, WEBLib.Dialogs,
  JS,
  ErrorListType;

type
  TResultType = class
  private
    fCount: LongWord;
    fCode: String;
    fMessage: String;
    fErrorList: TErrorListType;
  public
    property Count: LongWord read fCount;
    property Code: String read fCode;
    property Message: String read fMessage;
    property ErrorList: TErrorListType read fErrorList;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TResultType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fCount := StrToInt(String(JSObject_Type['count']));
    fCode := String(JSObject_Type['code']);
    fMessage := String(JSObject_Type['message']);
    fErrorList := TErrorListType.Create(TJSJSON.stringify(JSObject_Type['errorList']));
  end;
end;

end.
